function updateNav () {
  const pos = $(window).scrollTop()
  const $menu = $('nav')

  if (window.menuIsSticky && pos <= 136) {
    $menu.removeClass('sticky')
    window.menuIsSticky = false
  } else if (!window.menuIsSticky && pos > 136) {
    $menu.addClass('sticky')
    window.menuIsSticky = true
  }
}

function addMoreButton ($mainNav) {
  let $moreMenu = $mainNav.find('.nav-item.nav-item-more')
  if (!$moreMenu.length) {
    $moreMenu = $('<li class="nav-item nav-item-more"><a href="#">Meer <i class="icon-chevron-down"></i></a><ul></ul></li>')
    $mainNav.find('.nav-item.nav-item-system').first().before($moreMenu)
    $moreMenu.find('a').on('click', function (e) {
      e.preventDefault()
      $moreMenu.toggleClass('open')
    })
    $moreMenu.on('click', '.nav-item', function () {
      $moreMenu.removeClass('open')
    })
  }

  return $moreMenu
}

function updateMoreButton () {
  // Get width of all the essential elements
  const $allNavs = $('nav.nav-district, nav.nav-school')
  const $mainNav = $allNavs.last()
  const containerWidth = $mainNav.find('.container').innerWidth()
  const $essentialItems = $mainNav.find('.nav-item.nav-item-system, .logout-button, .logo, .school-selector')
  const essentialItemsWidth = $essentialItems.get().reduce((acc, el) => acc + $(el).innerWidth(), 0)

  // Calculate total available width for menu items
  const availableWidth = containerWidth - essentialItemsWidth - 150

  // Go over each of the menu items to see if we should move them into the 'More' menu
  let hasMoreMenu = false
  let spaceClaimed = 0
  $mainNav.find('.nav-item.nav-item-page').each(function () {
    // Calculate and store element width
    // (we store it to make sure we still know the original width after moving into 'More' menu)
    const el = $(this)
    if (!el.data('space-claimed')) {
      el.data('space-claimed', el.innerWidth())
    }
    spaceClaimed += Number(el.data('space-claimed'))

    // Move into or out of 'More' menu
    if (spaceClaimed > availableWidth) {
      hasMoreMenu = true
      addMoreButton($mainNav).find('ul').append(el)
      if (el.find('a').hasClass('active')) {
        el.parents('.nav-item-more').first().find('a').first().addClass('active')
      }
    } else if (el.parents('.nav-item-more').length) {
      $mainNav.find('.nav-item-more, .nav-item-system').first().before(el)
    }
  })

  // Clean up more menu if it's empty
  if (!hasMoreMenu) {
    $mainNav.find('.nav-item.nav-item-more').remove()
  }

  // Clean up more menu if the menu is not the main one anymore
  if ($allNavs.length === 2) {
    $('nav.nav-district .nav-item.nav-item-page').each(function () {
      const el = $(this)
      $('nav.nav-district .nav-item.nav-item-system').first().before(el)
    })
    $('nav.nav-district .nav-item.nav-item-more').remove()
  }
}

if ($(window).width() > 1000) {
  $(window).scroll(throttle(updateNav, 100))

  updateMoreButton()
  $(window).resize(updateMoreButton)
  $(document).on('pjax:end', updateMoreButton)
  $(document).on('pjax:end', () => setTimeout(updateMoreButton, 1000))
}
